import Skeleton from 'react-loading-skeleton';

import { brandColors } from '@/app/constants';

const ActivityLogsLoader = () => {
  return (
    <div className="grid gap-1">
      <Skeleton height={40} baseColor={brandColors.lightSilver} />
      <Skeleton height={40} baseColor={brandColors.lightSilver} />
      <Skeleton height={40} baseColor={brandColors.lightSilver} />
      <Skeleton height={40} baseColor={brandColors.lightSilver} />
      <Skeleton height={40} baseColor={brandColors.lightSilver} />
      <Skeleton height={40} baseColor={brandColors.lightSilver} />
      <Skeleton height={40} baseColor={brandColors.lightSilver} />
      <Skeleton height={40} baseColor={brandColors.lightSilver} />
      <Skeleton height={40} baseColor={brandColors.lightSilver} />
      <Skeleton height={40} baseColor={brandColors.lightSilver} />
    </div>
  );
};

export default ActivityLogsLoader;
